<template>
  <div class="c-header">

    <div class="c-header-nav">
      <div class="c-header-logo">
        <img src="../assets/images/logo.png" alt="Logo Audi">
      </div>
      <a href="/">
        <div class="c-header-nav-title">
          <div>
            Audi
          </div>
          <div>
            Krotoski-Cichy Warszawa
          </div>
        </div>
      </a>
    </div>
    <h1>Wyszukiwarka samochodów nowych</h1>
  </div>
</template>
<script>
export default {
  name: 'Header'
}
</script>
<style lang="scss">
  .c-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    height: 77px;
    &-logo{
      height: 30px;
      width: 85px;
      float: left;
      margin-right: 1rem;
      img{
        width: 100%;
        height: auto;
        margin-top: 2px;
      }
    }
    &-nav{
      a{
        color: #000;
      }
      &-title{
        float: right;
        div{
          font-size: 14px;
          font-weight: 500;
        }
        div:first-of-type{
          color: #c03;
          font-weight: 700;
        }
      }
    }
    h1{
      font-size: 2rem;
      font-weight: 500;
      display: inline-block;
    }
  }
</style>
